import * as React from "react";
import { SVGProps } from "react";
const SvgHome = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.107 16.553A1 1 0 0 0 2.001 18h3.982v8c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-8h4c.3 0 .7-.2.9-.5.2-.3.1-.6 0-.9l-6-12c-.2-.4-.5-.6-.9-.6h-16c-.4 0-.7.2-.9.6L1.107 16.553ZM23.983 25h-16v-7h16v7Zm-20.4-9 5-10h14.8l5 10h-24.8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHome;
